
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MentorshipOfferingForm, MentorshipFormData } from "@/components/mentor/MentorshipOfferingForm";

interface OfferingDialogsProps {
  isCreateDialogOpen: boolean;
  setIsCreateDialogOpen: (isOpen: boolean) => void;
  isEditDialogOpen: boolean;
  setIsEditDialogOpen: (isOpen: boolean) => void;
  editingOffering: MentorshipFormData | null;
  handleCreateOffering: (formData: MentorshipFormData, coverFile?: File | null) => Promise<void>;
  handleUpdateOffering: (formData: MentorshipFormData, coverFile?: File | null) => Promise<void>;
}

export const OfferingDialogs: React.FC<OfferingDialogsProps> = ({
  isCreateDialogOpen,
  setIsCreateDialogOpen,
  isEditDialogOpen,
  setIsEditDialogOpen,
  editingOffering,
  handleCreateOffering,
  handleUpdateOffering,
}) => {
  return (
    <>
      {/* Create Dialog */}
      <Dialog open={isCreateDialogOpen} onOpenChange={(open) => !open && setIsCreateDialogOpen(false)} modal>
        <DialogContent 
          className="bg-[#1E293B] text-white border-[#2A3749] max-w-2xl max-h-[90vh] overflow-y-auto"
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <DialogHeader className="sticky top-0 bg-[#1E293B] z-10 pb-4 border-b border-[#2A3749]">
            <DialogTitle className="text-white">Criar Nova Mentoria</DialogTitle>
            <DialogDescription className="text-gray-400">
              Preencha os detalhes para criar uma nova mentoria
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            <MentorshipOfferingForm
              onSubmit={handleCreateOffering}
              onCancel={() => setIsCreateDialogOpen(false)}
            />
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={isEditDialogOpen} onOpenChange={(open) => !open && setIsEditDialogOpen(false)} modal>
        <DialogContent 
          className="bg-[#1E293B] text-white border-[#2A3749] max-w-2xl max-h-[90vh] overflow-y-auto"
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <DialogHeader className="sticky top-0 bg-[#1E293B] z-10 pb-4 border-b border-[#2A3749]">
            <DialogTitle className="text-white">Editar Mentoria</DialogTitle>
            <DialogDescription className="text-gray-400">
              Altere os detalhes da sua mentoria
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            {editingOffering && (
              <MentorshipOfferingForm
                initialData={editingOffering}
                onSubmit={handleUpdateOffering}
                onCancel={() => setIsEditDialogOpen(false)}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
